<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <!-- 选择客户 -->
          <div class="tool" v-if="global.type == 'manage'">
            <h4>选择客户</h4>
            <div class="search">
              <el-select
                v-model="customerValue"
                placeholder="请选择客户"
                @change="customerChange"
                :loading="customerLoading"
                filterable>
                <el-option
                  v-for="item in customerData"
                  :key="item.client_id"
                  :label="item.number + ' ' + item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 提示词输入区 -->
          <div class="part">
            <div class="prompt_header">
              <h5>提示词</h5>
              <div class="prompt_actions">
                <el-button type="success" size="small" plain @click="handleAIEnhance" :loading="enhanceLoading" :disabled="!prompt || !prompt.trim()">
                  <i class="el-icon-magic-stick"></i> AI扩写润色
                </el-button>
                <el-button type="success" size="small" plain @click="handlePromptLibrary">
                  <i class="el-icon-reading"></i> 提示词库
                </el-button>
              </div>
            </div>
            <el-input
              type="textarea"
              :rows="6"
              placeholder="输入视频描述内容，例如：现代简约客厅，阳光从窗户洒入，镜头缓慢推进"
              v-model="prompt"
              maxlength="1000"
              show-word-limit>
            </el-input>
          </div>

          <!-- 选择模型 -->
          <div class="part">
            <h5>AI大模型</h5>
            <div class="">
              <el-radio-group v-model="aiSelected" @input="aiChange">
                <div class="ai_box">
                  <el-radio v-for="(item,index) in aiModels" :key="'ai'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-radio>
                </div>
              </el-radio-group>
            </div>
            <el-divider content-position="left">视频时长</el-divider>
            <el-radio-group v-model="durationCur">
              <div class="duration_box">
                <el-radio v-for="(item,index) in durationData" :key="'duration'+index" :label="index">{{ item + 's' }}</el-radio>
              </div>
            </el-radio-group>
          </div>

          <!-- 生成按钮 -->
          <div class="btn_save">
            <el-button
              type="success"
              :loading="isGenerating"
              @click="handleGenerate"
              :disabled="!prompt || !customerValue || !aiSelected"
              style="width:100%;">
              {{ isGenerating ? '生成中...' : '立即生成' }}
            </el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>

          <!-- 生成结果 -->
          <div class="part" v-if="generatedVideos.length > 0">
            <h5>生成结果</h5>
            <div class="result_grid video_grid">
              <div
                v-for="(video, index) in generatedVideos"
                :key="'result'+index"
                class="result_item video_item">
                <video :src="video.file_url" controls class="result_video"></video>
                <div class="result_info">
                  <p class="result_model">{{ video.model_name }}</p>
                  <div class="result_actions">
                    <el-button size="mini" type="success" plain @click="toDownload(video)">下载</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 生成中状态 -->
          <div class="part generating_status" v-if="isGenerating">
            <div class="status_content">
              <i class="el-icon-loading"></i>
              <p>视频生成中，预计需要1-3分钟，请耐心等待...</p>
              <el-progress :percentage="generateProgress" :format="formatProgress"></el-progress>
            </div>
          </div>

          <!-- 优质案例 -->
          <div class="example_section" v-if="examples.length > 0">
            <div class="example_header">
              <h5>优质案例</h5>
            </div>
            <div class="example_grid">
              <div
                v-for="item in examples"
                :key="'example'+item.id"
                class="example_item"
                @click="previewExample(item)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
                <div class="video_tag" v-if="item.video_url">
                  <i class="el-icon-video-play"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 提示词库弹窗 -->
        <el-dialog
          title="提示词库"
          :visible.sync="libraryVisible"
          width="70%"
          :close-on-click-modal="false">
          <div class="library_content">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item v-for="(item, index) in lexiconLabelData" :key="'lexiconLabel'+index" :index="index.toString()">{{ item }}</el-menu-item>
            </el-menu>
            <div class="lexicon_list">
              <el-checkbox-group v-model="lexiconCheckList" v-if="lexiconData[activeIndex] && lexiconData[activeIndex].length > 0">
                <el-checkbox v-for="(item, index) in lexiconData[activeIndex]" :key="'lexicon'+index" :label="item.word"></el-checkbox>
              </el-checkbox-group>
              <div class="" v-if="!lexiconData[activeIndex] || lexiconData[activeIndex].length <= 0">
                <el-empty :image-size="50" description="暂无数据"></el-empty>
              </div>
            </div>
            <div class="choose_list" v-if="lexiconCheckList.length > 0">
              <el-tag
                v-for="(item, index) in lexiconCheckList"
                :key="'choose' + index"
                :closable="true"
                :disable-transitions="true"
                @close="handleClose(index)"
                type="success">
                {{item}}
              </el-tag>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="libraryVisible = false">取消</el-button>
            <el-button type="success" @click="confirmLexicon">确定</el-button>
          </div>
        </el-dialog>

        <!-- 示例详情弹窗 -->
        <el-dialog
          title="示例详情"
          :visible.sync="exampleDetailVisible"
          width="80%"
          top="5vh"
          :close-on-click-modal="true"
          custom-class="example-detail-dialog"
          @close="onExampleDialogClose">
          <div class="example_detail" v-if="currentExample">
            <div class="detail_left">
              <!-- 有视频则显示视频，否则显示图片 -->
              <video
                v-if="currentExample.video_url"
                ref="exampleVideo"
                :src="currentExample.video_url"
                :poster="currentExample.photo_url"
                controls
                class="detail_video">
              </video>
              <img v-else :src="currentExample.photo_url" alt="">
            </div>
            <div class="detail_right">
              <div class="detail_item">
                <label>提示词/描述：</label>
                <p>{{ currentExample.description }}</p>
              </div>
              <div class="detail_item">
                <label>使用模型：</label>
                <p>{{ currentExample.model_name }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.style_type">
                <label>风格类型：</label>
                <p>{{ currentExample.style_type }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.space_type">
                <label>空间类型：</label>
                <p>{{ currentExample.space_type }}</p>
              </div>
              <div class="detail_actions">
                <el-button type="success" @click="useThisExample">使用此提示词</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SideBarComponent from '@/components/SideBarComponent'
import SubTitleComponent from '@/components/SubTitleComponent'

let _ajaxType = 0

export default {
  name: 'TextToVideo',
  components: {
    HeaderComponent,
    SideBarComponent,
    SubTitleComponent
  },
  data() {
    return {
      title: '文生视频',
      customerData: [],
      customerValue: '',
      customerLoading: false,
      prompt: '',
      aiModels: [],
      aiSelected: '',
      durationData: [5, 10],
      durationCur: 0,
      isGenerating: false,
      enhanceLoading: false,
      generatedVideos: [],
      generateProgress: 0,
      pollTimer: null,
      effectId: '',
      // 优质示例
      examples: [],
      exampleDetailVisible: false,
      currentExample: null,
      // 提示词库
      libraryVisible: false,
      activeIndex: '0',
      lexiconLabelData: [],
      lexiconData: [],
      lexiconCheckList: []
    }
  },
  created() {
    this.getCustomerList()
    this.getAIModelList()
    this.getLexiconData()
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
    }
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.customerLoading = true
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        let _data = json.data.data
        if (json.data.errcode === 0) {
          this.customerData = _data.result
          // 如果是客户端，自动选中当前客户
          if (this.global.type === 'client' && this.global.clientId) {
            this.customerValue = parseInt(this.global.clientId)
          }
          // 如果是管理端且只有一个客户，自动选中
          else if (this.customerData.length === 1) {
            this.customerValue = this.customerData[0].client_id
          }
          // 如果管理端有记忆的客户名称，自动选中
          else if (this.global.type === 'manage' && this.global.clientName) {
            const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
            if (rememberedClient) {
              this.customerValue = rememberedClient.client_id
            }
          }
          // 默认选择第一个客户
          else if (this.customerData.length > 0 && !this.customerValue) {
            this.customerValue = this.customerData[0].client_id
          }
        }
      }).finally(() => {
        this.customerLoading = false
      })
    },
    // 客户选择变化
    customerChange(val) {
      const selectedCustomer = this.customerData.find(c => c.client_id === val)
      if (selectedCustomer) {
        this.global.clientId = selectedCustomer.client_id
        this.global.clientName = selectedCustomer.client_name
      }
    },
    // 获取AI模型列表
    getAIModelList() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 5  // 5=文生视频模型
      }
      this.axios.post(_url, _aiData).then(json => {
        if (json.data.errcode === 0) {
          this.aiModels = json.data.data.result
          // 获取优质示例
          if (json.data.data.examples) {
            this.examples = json.data.data.examples
          }
          // 默认选中第一个
          if (this.aiModels.length > 0) {
            this.aiSelected = this.aiModels[0].model_id
            // 设置默认时长选项
            if (this.aiModels[0].config && this.aiModels[0].config.duration) {
              this.durationData = this.aiModels[0].config.duration
            }
          }
        }
      })
    },
    // 模型切换
    aiChange(val) {
      let nowAi = this.aiModels.find(c => c.model_id === val)
      if (nowAi && nowAi.config && nowAi.config.duration) {
        this.durationData = nowAi.config.duration
        this.durationCur = 0
      }
    },
    // 获取提示词库
    getLexiconData() {
      let _url = "/api/?mod=lexicon"
      this.axios.post(_url).then(json => {
        if (json.data.errcode === 0) {
          let _data = json.data.data.result
          this.lexiconLabelData = _data.map(item => item.label)
          this.lexiconData = _data.map(item => item.lexicon)
        }
      })
    },
    // AI扩写润色
    handleAIEnhance() {
      if (!this.prompt || this.prompt.trim() === '') {
        this.$message.error('请先输入提示词')
        return
      }
      if (_ajaxType === 1) return
      _ajaxType = 1
      this.enhanceLoading = true
      let _url = "/api/?mod=translate&action=refine"
      let _uploadData = {
        description: this.prompt,
        language: 'cn'
      }
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        this.enhanceLoading = false
        if (json.data.errcode === 0) {
          this.prompt = json.data.data.description.replace('\n\n', '')
          this.$message.success('润色成功')
        }
      }).catch(() => {
        _ajaxType = 0
        this.enhanceLoading = false
      })
    },
    // 打开提示词库
    handlePromptLibrary() {
      this.libraryVisible = true
      this.lexiconCheckList = []
    },
    // 选择提示词库分类
    handleSelect(key) {
      this.activeIndex = key
    },
    // 移除已选提示词
    handleClose(index) {
      this.lexiconCheckList.splice(index, 1)
    },
    // 确认提示词选择
    confirmLexicon() {
      if (this.lexiconCheckList.length > 0) {
        this.prompt = this.lexiconCheckList.join('，')
      }
      this.libraryVisible = false
      this.lexiconCheckList = []
    },
    // 预览示例详情
    previewExample(item) {
      this.currentExample = item
      this.exampleDetailVisible = true
    },
    // 关闭示例弹窗时停止视频播放
    onExampleDialogClose() {
      if (this.$refs.exampleVideo) {
        this.$refs.exampleVideo.pause()
      }
    },
    // 使用此提示词
    useThisExample() {
      if (this.currentExample) {
        // 填充提示词
        if (this.currentExample.description) {
          this.prompt = this.currentExample.description
        }
        this.exampleDetailVisible = false
        this.$message.success('已应用示例配置')
      }
    },
    // 立即生成
    handleGenerate() {
      if (!this.prompt || this.prompt.trim() === '') {
        this.$message.error('请输入提示词')
        return
      }
      if (!this.customerValue) {
        this.$message.error('请选择客户')
        return
      }
      if (!this.aiSelected) {
        this.$message.error('请选择AI模型')
        return
      }
      if (_ajaxType === 1) return
      _ajaxType = 1

      this.isGenerating = true
      this.generateProgress = 0

      let _url = "/api/?mod=effect&action=text2video"
      let _data = {
        client_id: this.customerValue,
        description: this.prompt,
        model_id: this.aiSelected,
        duration: parseInt(this.durationData[this.durationCur])
      }

      // 检查模型是否需要英文
      let nowAi = this.aiModels.find(c => c.model_id === this.aiSelected)
      if (nowAi && nowAi.language === 'en') {
        this.translateAndGenerate(_data)
        return
      }

      this.axios.post(_url, _data).then(json => {
        if (json.data.errcode === 0) {
          this.effectId = json.data.data.effect_id
          this.$message.success('提交成功，正在生成中')
          this.pollResult()
        } else {
          _ajaxType = 0
          this.isGenerating = false
          this.$message.error(json.data.error || '生成失败')
        }
      }).catch(() => {
        _ajaxType = 0
        this.isGenerating = false
        this.$message.error('网络错误')
      })
    },
    // 翻译后生成
    translateAndGenerate(data) {
      let _url = "/api/?mod=translate"
      let _uploadData = {
        description: data.description
      }
      this.axios.post(_url, _uploadData).then(json => {
        if (json.data.errcode === 0) {
          data.description = json.data.data.description_en
          let _generateUrl = "/api/?mod=effect&action=text2video"
          this.axios.post(_generateUrl, data).then(json => {
            if (json.data.errcode === 0) {
              this.effectId = json.data.data.effect_id
              this.$message.success('提交成功，正在生成中')
              this.pollResult()
            } else {
              _ajaxType = 0
              this.isGenerating = false
              this.$message.error(json.data.error || '生成失败')
            }
          })
        } else {
          _ajaxType = 0
          this.isGenerating = false
          this.$message.error(json.data.error || '翻译失败')
        }
      }).catch(() => {
        _ajaxType = 0
        this.isGenerating = false
      })
    },
    // 轮询结果
    pollResult() {
      let _url = "/api/?mod=effect&action=result"
      let _data = {
        effect_id: this.effectId
      }
      this.axios.post(_url, _data).then(json => {
        if (json.data.errcode === 0) {
          let result = json.data.data.result
          if (result && result.length > 0) {
            let item = result[0]
            if (item.status === 'success') {
              // 生成成功
              _ajaxType = 0
              this.isGenerating = false
              this.generateProgress = 100
              this.generatedVideos.unshift({
                file_url: item.file_url,
                model_name: item.model_name || this.aiSelected
              })
              this.$message.success('视频生成成功')
              // 刷新余额
              this.axios.post('/api/?mod=user').then(json => {
                if (json.data.errcode === 0) {
                  this.global.money = json.data.data.user.money
                }
              })
            } else if (item.status === 'fail') {
              // 生成失败
              _ajaxType = 0
              this.isGenerating = false
              this.$message.error('视频生成失败，请重试')
            } else {
              // 继续轮询
              this.generateProgress = Math.min(this.generateProgress + 5, 95)
              this.pollTimer = setTimeout(() => {
                this.pollResult()
              }, 3000)
            }
          } else {
            // 继续轮询
            this.generateProgress = Math.min(this.generateProgress + 5, 95)
            this.pollTimer = setTimeout(() => {
              this.pollResult()
            }, 3000)
          }
        }
      }).catch(() => {
        // 继续轮询
        this.pollTimer = setTimeout(() => {
          this.pollResult()
        }, 3000)
      })
    },
    // 格式化进度
    formatProgress(percentage) {
      return percentage === 100 ? '完成' : `${percentage}%`
    },
    // 下载
    toDownload(video) {
      window.open(video.file_url, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.ai_main {
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.box {
  margin: 0 auto;
  padding: 10px;
}

.tool {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;

  h4 {
    margin: 0 0 15px 0;
    font-size: 16px;
    color: #333;
  }
}

.part {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;

  h5 {
    margin: 0 0 15px 0;
    font-size: 15px;
    color: #333;
  }
}

.prompt_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  h5 {
    margin: 0;
  }

  .prompt_actions {
    display: flex;
    gap: 10px;
  }
}

.ai_box,
.duration_box {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.btn_save {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;

  .prompt {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-top: 10px;
  }
}

.result_grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.video_grid {
  grid-template-columns: repeat(1, 1fr);
}

.result_item {
  background: #f5f7fa;
  border-radius: 8px;
  overflow: hidden;

  .result_video {
    width: 100%;
    max-height: 400px;
    object-fit: contain;
    background: #000;
  }

  .result_info {
    padding: 15px;

    .result_model {
      margin: 0 0 10px 0;
      font-size: 14px;
      color: #666;
    }

    .result_actions {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }
  }
}

.generating_status {
  .status_content {
    text-align: center;
    padding: 40px 20px;

    i {
      font-size: 48px;
      color: #67c23a;
      margin-bottom: 20px;
    }

    p {
      color: #666;
      margin-bottom: 20px;
    }
  }
}

.library_content {
  background: #fff;

  .lexicon_list {
    padding: 20px 0;
    min-height: 200px;
    background: #fff;
  }

  .choose_list {
    padding: 10px 0;
    border-top: 1px solid #eee;

    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}

// 示例展示样式
.example_section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;

  .example_header {
    margin-bottom: 15px;

    h5 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      margin: 0;
    }
  }

  .example_grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;

    .example_item {
      position: relative;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }

      .video_tag {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
}

// 示例详情弹窗样式
::v-deep .example-detail-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff !important;

  .el-dialog__header {
    background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%) !important;
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;

    .el-dialog__title {
      color: #fff !important;
      font-size: 18px !important;
      font-weight: 600 !important;
    }

    .el-dialog__headerbtn {
      top: 20px !important;
      right: 20px !important;

      .el-dialog__close {
        color: #fff !important;
        font-size: 20px !important;

        &:hover {
          color: rgba(255, 255, 255, 0.8) !important;
        }
      }
    }
  }

  .el-dialog__body {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
    background: #fff !important;
    padding: 0 !important;
  }
}

.example_detail {
  display: flex;
  gap: 30px;
  padding: 20px;
  background: #fff;

  .detail_left {
    flex: 1;

    img {
      width: 100%;
      max-height: 60vh;
      object-fit: contain;
      border-radius: 8px;
    }

    .detail_video {
      width: 100%;
      max-height: 60vh;
      border-radius: 8px;
      background: #000;
    }
  }

  .detail_right {
    flex: 1;

    .detail_item {
      margin-bottom: 15px;

      label {
        display: block;
        font-size: 14px;
        color: #999;
        margin-bottom: 5px;
      }

      p {
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }

    .detail_actions {
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TextToVideo/Index.vue